import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../store';
import { t } from '../../lib/i18n';

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 0 0-5.487 0 12.36 12.36 0 0 0-.617-1.23A.077.077 0 0 0 8.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 0 0 .031.055 20.03 20.03 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 0 1-1.872-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .079.009c.12.098.245.195.372.288a.075.075 0 0 1-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 0 0-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 0 0 .084.028 19.963 19.963 0 0 0 6.002-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

export const Footer: React.FC = () => {
  const { lang } = useStore();
  const year = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: '1px solid var(--glass-border)',
      background: 'rgba(5,7,13,0.9)',
      backdropFilter: 'blur(20px)',
      padding: '2.5rem 1.5rem 2rem',
      marginTop: 'auto',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem',
        }}>
          {/* Brand */}
          <div>
            <div style={{
              fontFamily: 'var(--font-display)',
              fontSize: '1.1rem',
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'var(--white)',
              marginBottom: '0.5rem',
            }}>
              Modern<br/>
              <span style={{ color: 'var(--cyan)', fontSize: '0.6em', letterSpacing: '0.3em' }}>Mercenaries</span>
            </div>
            <p style={{ fontSize: '0.78rem', color: 'var(--silver-dim)', lineHeight: 1.6, marginTop: '0.5rem' }}>
              {lang === 'fr'
                ? 'La plateforme de missions pour professionnels indépendants.'
                : 'The mission platform for independent professionals.'}
            </p>
            <div style={{ display: 'flex', gap: '0.6rem', marginTop: '1rem' }}>
              <a
                href="https://x.com/modernmercs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 34, height: 34,
                  border: '1px solid var(--navy-border)',
                  borderRadius: 'var(--radius)',
                  color: 'var(--silver-dim)',
                  transition: 'all 0.2s var(--ease)',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--cyan-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--cyan)';
                  (e.currentTarget as HTMLElement).style.background = 'var(--cyan-deep)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--navy-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--silver-dim)';
                  (e.currentTarget as HTMLElement).style.background = 'transparent';
                }}
              >
                <XIcon />
              </a>
              <a
                href="https://discord.gg/modernmercs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Discord"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 34, height: 34,
                  border: '1px solid var(--navy-border)',
                  borderRadius: 'var(--radius)',
                  color: 'var(--silver-dim)',
                  transition: 'all 0.2s var(--ease)',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--cyan-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--cyan)';
                  (e.currentTarget as HTMLElement).style.background = 'var(--cyan-deep)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--navy-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--silver-dim)';
                  (e.currentTarget as HTMLElement).style.background = 'transparent';
                }}
              >
                <DiscordIcon />
              </a>
              <a
                href="https://linkedin.com/company/modern-mercenaries"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 34, height: 34,
                  border: '1px solid var(--navy-border)',
                  borderRadius: 'var(--radius)',
                  color: 'var(--silver-dim)',
                  transition: 'all 0.2s var(--ease)',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--cyan-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--cyan)';
                  (e.currentTarget as HTMLElement).style.background = 'var(--cyan-deep)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--navy-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--silver-dim)';
                  (e.currentTarget as HTMLElement).style.background = 'transparent';
                }}
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://instagram.com/modernmercenaries"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 34, height: 34,
                  border: '1px solid var(--navy-border)',
                  borderRadius: 'var(--radius)',
                  color: 'var(--silver-dim)',
                  transition: 'all 0.2s var(--ease)',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--cyan-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--cyan)';
                  (e.currentTarget as HTMLElement).style.background = 'var(--cyan-deep)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--navy-border)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--silver-dim)';
                  (e.currentTarget as HTMLElement).style.background = 'transparent';
                }}
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          {/* Platform links */}
          <div>
            <div style={{
              fontFamily: 'var(--font-mono)',
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'var(--cyan)',
              marginBottom: '1rem',
            }}>
              {lang === 'fr' ? 'Plateforme' : 'Platform'}
            </div>
            {[
              { to: '/missions', label: lang === 'fr' ? 'Parcourir les missions' : 'Browse Missions' },
              { to: '/mercenaries', label: lang === 'fr' ? 'Trouver un mercenaire' : 'Find Mercenaries' },
              { to: '/missions/create', label: lang === 'fr' ? 'Publier une mission' : 'Post a Mission' },
            ].map(item => (
              <Link
                key={item.to}
                to={item.to}
                style={{
                  display: 'block',
                  fontSize: '0.82rem',
                  color: 'var(--silver-mid)',
                  marginBottom: '0.5rem',
                  transition: 'color 0.18s',
                  textDecoration: 'none',
                }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--cyan)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--silver-mid)')}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Legal */}
          <div>
            <div style={{
              fontFamily: 'var(--font-mono)',
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'var(--cyan)',
              marginBottom: '1rem',
            }}>
              {lang === 'fr' ? 'Légal' : 'Legal'}
            </div>
            {[
              { to: '/privacy', label: lang === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy' },
              { to: '/terms', label: lang === 'fr' ? "Conditions d'utilisation" : 'Terms of Use' },
              { to: '/privacy#cookies', label: lang === 'fr' ? 'Gestion des cookies' : 'Cookie Settings', id: 'cookie-settings-link' },
            ].map(item => (
              <Link
                key={item.to}
                to={item.to}
                id={item.id}
                style={{
                  display: 'block',
                  fontSize: '0.82rem',
                  color: 'var(--silver-mid)',
                  marginBottom: '0.5rem',
                  transition: 'color 0.18s',
                  textDecoration: 'none',
                }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--cyan)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--silver-mid)')}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(79,195,247,0.1)',
          paddingTop: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '0.75rem',
        }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.65rem', color: 'var(--silver-dim)' }}>
            © {year} Modern Mercenaries — MM//01 — Est. 2024
          </span>
          <span style={{
            fontFamily: 'var(--font-mono)',
            fontSize: '0.62rem',
            color: 'var(--silver-dim)',
            opacity: 0.6,
          }}>
            {lang === 'fr'
              ? 'Fait avec précision. Déployé avec intention.'
              : 'Built with precision. Deployed with intent.'}
          </span>
        </div>
      </div>
    </footer>
  );
};
